import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import { gql } from '@apollo/client';
import { nullable } from '@infl-ts/util-io-ts';
import { makeDecodedMutation } from '@infl-ts/util-make-apollo-decoded';
import * as t from 'io-ts';
import { UpdateLanguageOutput } from './codecs';
export var useUpdateProfileLanguage = makeDecodedMutation(gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    mutation UpdateProfileLanguage($input: EditProfileInput!) {\n      editProfile(input: $input) {\n        ... on EditProfileErrors {\n          errors {\n            ... on Error {\n              message\n            }\n          }\n        }\n        ... on EditProfileResult {\n          result {\n            id\n            language {\n              id\n              name\n              code\n              displayName\n            }\n          }\n        }\n      }\n    }\n  "]))), UpdateLanguageOutput, t.type({
  input: t.type({
    language: nullable(t.string)
  })
}));